import { render } from "./DreamTeamPlayerTile.vue?vue&type=template&id=6c848057&scoped=true"
import script from "./DreamTeamPlayerTile.vue?vue&type=script&lang=js"
export * from "./DreamTeamPlayerTile.vue?vue&type=script&lang=js"

import "./DreamTeamPlayerTile.vue?vue&type=style&index=0&id=6c848057&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c848057"]])

export default __exports__